import OfferTab from './OfferTab';

export default OfferTab;
